import './App.css';
import ComponetsContainer from './Dashboard-Components/ComponetsContainer';

function App() {
  return (
    <div className="App">
      <ComponetsContainer/>
    </div>
  );
}

export default App;
